module.exports = __webpack_public_path__ + "static/img/IMG_20170901_152559.4202ed5f.jpg";